"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("events");
class Logger extends events_1.EventEmitter {
    constructor() {
        super();
    }
    log(message, context) {
        this.emit("logging", Object.assign({ message }, context));
    }
}
exports.default = Logger;
class ConsoleInterceptor {
    constructor(prefix) {
        this.contextSuppliers = {};
        this.origConsole = {
            log: console.log,
            debug: console.debug,
            info: console.info,
            warn: console.warn,
            error: console.error,
        };
        this.prefix = prefix;
        console.log = (message, ...optionalParams) => this.logWith(this.origConsole.log, message, ...optionalParams);
        console.debug = (message, ...optionalParams) => this.logWith(this.origConsole.debug, message, ...optionalParams);
        console.info = (message, ...optionalParams) => this.logWith(this.origConsole.info, message, ...optionalParams);
        console.warn = (message, ...optionalParams) => this.logWith(this.origConsole.warn, message, ...optionalParams);
        console.error = (message, ...optionalParams) => this.logWith(this.origConsole.error, message, ...optionalParams);
    }
    logWith(origCall, message, ...optionalParams) {
        origCall.apply(this.origConsole, [message, ...optionalParams]);
        if (!this.logger)
            return;
        message = message.replace(/%[oOdisfc]/g, (m) => {
            switch (m) {
                case '%o':
                case '%O': return JSON.stringify(optionalParams.shift());
                case '%d':
                case '%i':
                case '%s':
                case '%f': return optionalParams.shift();
                case '%c':
                    optionalParams.shift();
                    return '';
                default: return m;
            }
        });
        const context = {};
        Object.entries(this.contextSuppliers).forEach(([key, s]) => context[key] = s());
        if (optionalParams.length > 0)
            context.logInfo = optionalParams;
        this.logger.log(this.prefix + message, context);
    }
    static interceptConsoleLogs(prefix) {
        return new ConsoleInterceptor(prefix);
    }
    restoreConsole() {
        console.log = this.origConsole.log;
        console.debug = this.origConsole.debug;
        console.info = this.origConsole.info;
        console.warn = this.origConsole.warn;
        console.error = this.origConsole.error;
    }
    setLogger(logger) {
        this.logger = logger;
    }
    addContext(name, contextSupplier) {
        this.contextSuppliers[name] = contextSupplier;
    }
    removeContext(name) {
        delete this.contextSuppliers[name];
    }
}
exports.ConsoleInterceptor = ConsoleInterceptor;
// Enable media-soup logs
window.localStorage.setItem('debug', 'mediasoup-client:*');
